import React from 'react';
import { FiEdit, FiTrash2 } from 'react-icons/fi';

const ProjectActionsCell = ({ projectId, onEdit, onDelete }) => {
    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            gap: '8px', 
            width: '100%', 
            margin: '0 auto' 
        }}>
            <button
                type="button"
                style={{
                    background: '#2563eb',
                    backgroundColor: '#2563eb',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '6px',
                    width: '32px',
                    height: '32px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    padding: 0,
                    flexShrink: 0
                }}
                onClick={() => onEdit(projectId)}
                title="Edit Project"
            >
                <FiEdit size={15} color="#ffffff" />
            </button>

            <button
                type="button"
                style={{
                    background: '#dc2626',
                    backgroundColor: '#dc2626',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '6px',
                    width: '32px',
                    height: '32px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    padding: 0,
                    flexShrink: 0
                }}
                onClick={() => onDelete(projectId)}
                title="Delete Project"
            >
                <FiTrash2 size={15} color="#ffffff" />
            </button>
        </div>
    );
};

export default ProjectActionsCell;
